import React, { useState, useEffect } from "react";
import moment from "moment";

const Timer = ({ timeValue }) => {

  const [deadlineTime, setDeadlineTime] = useState(null);
  const [flag, setflag] = useState(true);

  var now = moment(moment().utcOffset("+05:30").format("YYYY-MM-DD HH:mm:ss"));
  var then = moment(timeValue);

function durationAsString(ms, maxPrecission = 4) {
    const duration = moment.duration(ms);
    const items = [];
    items.push({ timeUnit: "d", value: Math.floor(duration.asDays()) });
    items.push({ timeUnit: "h", value: duration.hours() });
    items.push({ timeUnit: "m", value: duration.minutes() });
    items.push({ timeUnit: "s", value: duration.seconds() });

    const formattedItems = items.reduce((accumulator, { value, timeUnit }) => {
      if (
        accumulator.length >= maxPrecission ||
        (accumulator.length === 0 && value === 0)
      ) {
        return accumulator;
      }

      accumulator.push(`${value}${timeUnit}`);
      return accumulator;
    }, []);

    setDeadlineTime(
      formattedItems.length !== 0 ? formattedItems.join(" ") : "-"
    );
  }

  useEffect(() => {
    const startTime = then.diff(now);
    const intervalId = setInterval(() => {
    setflag(!flag);
    }, 1000);
    durationAsString(startTime);
    return () => clearInterval(intervalId);
  },[flag]);

  return <div>{deadlineTime ? <p>{deadlineTime}</p> : ""}</div>;
};

export default Timer;
